import _objectSpread from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
var _excluded = ["rule", "fn", "opts"];
import { toNumber } from './internal/utils.js';

/**
 * Holiday Rule
 * Apart from `rule` and `name` other options may be set
 * @constructor
 * @param {object} ruleObj
 * @param {string} ruleObj.rule - the rule string
 * @param {string|object} [ruleObj.name] - the name of the holiday, plain or with i18n
 * @param {string} [ruleObj.type] - type of holiday
 * @param {boolean} [ruleObj.substitute] - substitute holiday
 * @param {object[]} [ruleObj.active] - active `[{from?: str, to?: str}]`
 */
export var HolidayRule = /*#__PURE__*/function () {
  function HolidayRule(ruleObj) {
    _classCallCheck(this, HolidayRule);
    var rule = ruleObj.rule,
      fn = ruleObj.fn,
      opts = ruleObj.opts,
      other = _objectWithoutProperties(ruleObj, _excluded);
    Object.assign(this, _objectSpread({
      rule: rule
    }, other));
  }

  /**
   * disable rule in year (month)
   * @param {number} year
   * @param {number} [month] - 1..12
   */
  _createClass(HolidayRule, [{
    key: "disableIn",
    value: function disableIn(year, month) {
      if (!toNumber(year)) return;
      month = month < 1 && month > 12 ? undefined : month < 10 ? '0' + Number(month) : month;
      var dateStr = [year, month].filter(Boolean).join('-');
      this.disable = (this.disable || []).concat(dateStr).sort();
    }
  }]);
  return HolidayRule;
}();